
export type ServiceType =
  | 'gesso_simples'
  | 'forro_reforcado'
  | 'parede_bloco'
  | 'moldura'
  | 'dilatacao'
  | 'reboco'
  | 'revestimento'
  | 'reboco_separado'
  | 'parede_bloco_separado'
  | 'revestimento_separado';

export type CalcCategory = 'area' | 'linear' | 'parede' | 'unidade' | 'parede_simples';

export interface CustomService {
  id: string;
  name: string;
  price: number;
  category: CalcCategory;
}

export interface UserProfile {
  id: string;
  full_name: string;
  company_name: string;
  prices: {
    [key: string]: number;
  };
  custom_services?: CustomService[];
}

export interface BudgetItem {
  id?: string;
  room_id?: string; // ID do cômodo a que este item pertence
  service_type: string; // Pode ser ServiceType ou ID de serviço customizado
  manual_name?: string; // Nome personalizado para itens temporários
  quantity: number; // m, m2 ou unidade
  unit_price: number;
  subtotal: number;
}

export interface ManualItem {
  id: string;
  name: string;
  value: number | string;
}

export interface Room {
  id: string;
  name: string;
  width: number | string;
  depth: number | string;
  height: number | string;
  selected_services: string[];
  manual_items?: ManualItem[];
  // Os itens serão vinculados pelo room_id, mas na interface visual podem estar aninhados ou filtrados
}

export interface Budget {
  id: string;
  client_name: string;
  client_phone?: string;
  notes?: string;
  width?: number; // Depreciado em favor de rooms, mantido para compatibilidade
  depth?: number; // Depreciado
  height?: number; // Depreciado
  rooms?: Room[]; // Nova estrutura de cômodos
  selected_services?: string[];
  items: BudgetItem[];
  total_value: number;
  status: 'pendente' | 'aprovado' | 'cancelado';
  created_at: string;
}

export const SERVICE_LABELS: Record<string, string> = {
  gesso_simples: 'Gesso simples (m²)',
  forro_reforcado: 'Forro Reforçado (m²)',
  parede_bloco: 'Parede de bloco (m²)',
  moldura: 'Moldura (m)',
  dilatacao: 'Dilatação (m)',
  reboco: 'Reboco (m²)',
  revestimento: 'Revestimento (m²)',
  reboco_separado: 'Reboco (separado) (m²)',
  parede_bloco_separado: 'Parede de bloco (separado) (m²)',
  revestimento_separado: 'Revestimento (separado) (m²)'
};

export const SERVICE_CATEGORIES: Record<string, CalcCategory> = {
  gesso_simples: 'area',
  forro_reforcado: 'area',
  parede_bloco: 'parede',
  moldura: 'linear',
  dilatacao: 'linear',
  reboco: 'parede',
  revestimento: 'parede',
  reboco_separado: 'parede_simples',
  parede_bloco_separado: 'parede_simples',
  revestimento_separado: 'parede_simples'
};

export const getServiceLabel = (type: string, profile?: UserProfile | null) => {
  if (SERVICE_LABELS[type]) return SERVICE_LABELS[type];
  const custom = profile?.custom_services?.find(s => s.id === type);
  if (custom) {
    const unit = custom.category === 'area' ? ' (m²)' : custom.category === 'linear' ? ' (m)' : '';
    return `${custom.name}${unit}`;
  }
  return type;
};

export const getServiceCategory = (type: string, profile?: UserProfile | null): CalcCategory => {
  if (SERVICE_CATEGORIES[type]) return SERVICE_CATEGORIES[type];
  const custom = profile?.custom_services?.find(s => s.id === type);
  return custom?.category || 'unidade';
};
